import { render, staticRenderFns } from "./base-account.vue?vue&type=template&id=389791ed&scoped=true&"
import script from "./base-account.vue?vue&type=script&lang=js&"
export * from "./base-account.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389791ed",
  null
  
)

export default component.exports